import 'mapbox-gl/dist/mapbox-gl.css';
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { Permission } from "~/hooks/permissions";
import TabsPage from "~/components/layout/TabsPage";
import TabRoles from './TabRoles';
import TabSettings from './TabSettings';

const SecurityPage = () => {
  const { loading } = useOrgConfig();

  return <TabsPage basePath="security" loading={loading} tabs={{
    'settings': {
      label: 'Security Settings',
      permission: Permission.manageOrgConfig,
      component: () => <TabSettings />,
    },
    'roles': {
      label: 'Roles',
      permission: Permission.manageOrgConfig,
      component: () => <TabRoles />,
    },
  }}/>
}

export default SecurityPage;
